<template>
    <b-modal title="নতুন অফিস তৈরি" hide-footer size="md"  v-model="largeModal" >
        <form @submit.prevent="addContact">
            <div class="container custom_modal_body">
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">অফিসের নাম <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <input type="text" @keypress="errorClear('name')"  v-validate="'required'" v-model="newContact.name" class="form-control" name="name" placeholder="অফিসের নাম">
                        <p v-show="errors.has('name')"  style="color:red">* {{ errors.first('name') }}</p>
                        <p style="color:red" v-if="servererrors"><span v-for="(error,key) in servererrors.name" :key="key"><span style="color:red">*{{error}}</span></span></p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">অফিসের ধরন <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <select v-model="newContact.ofc_type" @keypress="errorClear('ofc_type')" name="ofc_type" class="form-control" v-validate="'required'">
                            <option value="">সিলেক্ট করুন</option>
                            <option value="প্রধান অফিস">প্রধান অফিস</option>
                            <option value="শাখা অফিস">শাখা অফিস</option>
                            <option value="অন্যান্য">অন্যান্য</option>
                        </select>
                        <p v-show="errors.has('ofc_type')" style="color:red">* This is required field</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">মালিকানার ধরণ <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <select v-validate="'required'" v-model="newContact.malikana_type" @keypress="errorClear('malikana_type')" name="malikana_type" class="form-control">
                            <option value="">সিলেক্ট করুন</option>
                            <option value="ব্যাক্তি মালিকানা">ব্যাক্তি মালিকানা</option>
                            <option value="নিজস্ব">নিজস্ব</option>
                        </select>
                        <p v-show="errors.has('malikana_type')" style="color:red">* This is required field</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">যে তলায় অবস্থিত</label>
                    <div class="col-sm-8">
                        <input type="text" @keypress="errorClear('which_storied')" v-model="newContact.which_storied" class="form-control" name="which_storied" placeholder="যে তলায় অবস্থিত">
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">কর্মচারী সংখ্যা</label>
                    <div class="col-sm-8">
                        <input type="text" @keypress="errorClear('ofc_staff')" v-model="newContact.ofc_staff" class="form-control" name="ofc_staff" placeholder="কর্মকর্তা-কর্মচারী সংখ্যা">
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">ঠিকানা</label>
                    <div class="col-sm-8">
                        <input name="ofc_address" v-validate="'required'" @keypress="errorClear('ofc_address')"  type="text" v-model="newContact.ofc_address" class="form-control"  placeholder="ঠিকানা">
                        <p v-show="errors.has('ofc_address')" style="color:red">* This is required field</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">মোবাইল নম্বর <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <input type="text" @keypress="errorClear('mobile_number')"  v-validate="'required|numeric'" v-model="newContact.mobile_number" class="form-control" name="phone" placeholder="মোবাইল নম্বর">
                        <p v-show="errors.has('phone')"  style="color:red">* This is required field</p>
                        <p style="color:red" v-if="servererrors"><span v-for="(error,key) in servererrors.mobile_number" :key="key"><span style="color:red">*{{error}}</span></span></p>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <input type="submit" value="Submit" v-if="!addContactLoader"  class="btn btn-primary pull-right">
                        <button v-if="! addContactLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                        <button v-if="addContactLoader" class="btn btn-primary pull-right" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Submitting...
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)

import { ADD_OFC_CONTACT,OPEN_CONTACT_MODAL,CLOSE_CONTACT_MODAL,ALL_USER_ROLE,UPDATE_CONTACT} from "../../store/action.type"
import { ADD_CONTACT_LOADER} from "../../store/mutation.type"
import { mapState,mapGetters } from "vuex"
export default {
    data(){
        return{
            servererrors:'',
            addContactLoader:false,
            index:'',
            largeModal:false,
            newContact:{
                type:2,
                name:'',
                ofc_address:'',
                mobile_number:'',
                ofc_type:'',
                malikana_type:'',
                ofc_staff:'',
                which_storied: ''
            }
        }
    },
    methods:{
        errorClear(fields)
        {
            delete this.servererrors[fields];
        },
        close(){
            this.largeModal = false
        },
        addContact () {
            if(this.index >= 0){
                this.updateContact();
            }
            else{
                this.$validator.validateAll().then( result =>{
                    if(result){
                        var data = this.newContact
                        this.addContactLoader = true;
                        this.$store.dispatch('ADD_OFC_CONTACT',data)
                        .then(response=>{
                            this.addContactLoader=false;
                            this.largeModal = false
                        })
                        .catch(error=>{
                            this.addContactLoader=false;
                            this.servererrors = error.response.data.errors;
                        });
                    }

                })
            }

        },
        clearInput(){
            this.newContact.type = ''
            this.newContact.mobile_number = ''
            this.newContact.ofc_type = ''
            this.newContact.ofc_address = ''
            this.newContact.name = ''
            this.malikana_type = '',
            this.ofc_staff = '',
            this.which_storied = ''
        },
        openModal(){
            this.index = -1
            this.largeModal = true
            this.newContact.name = ""
            this.newContact.ofc_type = ""
            this.newContact.ofc_address = ""
            this.newContact.mobile_number = ""
            this.servererrors = ""
            this.newContact.malikana_type = ""
            this.newContact.ofc_staff = ""
            this.newContact.which_storied = ""
        },

        allRole(){
            this.$store.dispatch('ALL_USER_ROLE')
        },
    },
    mounted(){
    },
    computed:{

    }

}
</script>

<style>
.custom_modal_body{
    overflow: auto;
    min-height: auto;
}
.logo_upload{
    border: 1px solid #ccc;
    width: 100%;
    height: 90px;
    background: #eceef0;
    text-align: center;
    cursor: pointer;
}
.image_upload p{
    margin-top: 10px;
    font-size: 12px;
}

.image_upload i{
    font-size: 34px;
}
.removeImage{
   position: absolute;
    right: 13px;
    top:  14px;
    color: var(--white);
    border: 1px solid;
    border-radius: 25px;
    padding: 4px 8px;
    background-color: #fb1212f5;
    font-size: 10px;
    font-family: cursive;
}
.fitimage {
    width: 32%;
    height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    background-color: #e6e6ef;
}
.required{
    color: red;
}
</style>
